<template>
    <div>
        <span v-if="label" :class="['label', {'bolder': bolderLabel}]">{{ label }}</span>
        <v-combobox
            v-model="model"
            :filter="filter"
            :hide-no-data="!search"
            :items="tags"
            :search-input.sync="search"
            hide-selected
            aria-autocomplete="none"
            :label="placeholder"
            multiple
            small-chips
            solo flat
            outlined dense
            hide-details
            color="secondary"
        >
            <template v-slot:no-data>
                <v-list-item>
                    <span class="subheading mr-1">{{ $t('common.create').toLowerCase() }}:</span>
                    <v-chip color="secondary" label small>
                        {{ search }}
                    </v-chip>
                </v-list-item>
            </template>
            <template v-slot:selection="{ attrs, item, parent, selected }">
                <v-chip
                    v-bind="attrs"
                    color="secondary"
                    :input-value="selected"
                    label small
                >
                    {{ item }}
                    <v-icon x-small @click="parent.selectItem(item)" right>
                        $close
                    </v-icon>
                </v-chip>
            </template>
            <template v-slot:item="{ index, item }">
                <v-chip color="grey" dark label small>
                    {{ item.text }}
                </v-chip>
            </template>
        </v-combobox>
    </div>

</template>

<script>
import _map from 'lodash/map'

export default {
    name: "KimsaTagsPicker",
    props: {
        label: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default() {
                return this.$t('inputs.tags_picker_placeholder')
            }
        },
        defaultTags: {
            type: Array,
            default: () => []
        },
        bolderLabel: {
            type: Boolean,
            default: false
        },
        forceValue: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            activator: null,
            attach: null,
            editing: null,
            editingIndex: -1,
            tags: [],
            nonce: 1,
            menu: false,
            model: [],
            search: null,
        }
    },
    mounted() {
        this.setDefaults()
    },
    methods: {
        reset() {
            const vm = this
            vm.tags = []
            vm.model = []
            vm.nonce = 1
            vm.search = null
            vm.menu = false
        },
        setDefaults() {
            const vm = this
            // console.log('vm.defaultTags',vm.defaultTags)
            if (vm.defaultTags.length > 0 || vm.forceValue) vm.model = vm.defaultTags
        },
        edit(index, item) {
            if (!this.editing) {
                this.editing = item
                this.editingIndex = index
            } else {
                this.editing = null
                this.editingIndex = -1
            }
        },
        filter(item, queryText, itemText) {
            if (item.header) return false

            const hasValue = val => val != null ? val : ''

            const text = hasValue(itemText)
            const query = hasValue(queryText)

            return text.toString()
                .toLowerCase()
                .indexOf(query.toString().toLowerCase()) > -1
        },
    },
    watch: {
        model(val, prev) {
            const vm = this
            if (val.length === prev.length) return
            vm.model = val.map(v => {
                if (typeof v === 'string') {
                    v = {text: v}
                    vm.tags.push(v)
                    vm.nonce++
                }
                return v
            })

            vm.$nextTick(function () {
                vm.$emit('change', _map(vm.model, 'text'))
            })
        },
        defaultTags() {
            this.setDefaults()
        }
    }
}
</script>

<style scoped>

.label {
    font-size: 15px;
    color: #333333;
}

.bolder {
    font-weight: 700;
}

</style>